<div [class]="skinName">
  <div id="account-success" [ngClass]="{'pay-success-align': !paymentDialog,'no-margin': pageDetail === 'operator'}">
    <div id="success-card" [ngClass]="{'payment-bg': !paymentDialog,'no-border': pageDetail === 'operator'}">
      <div class="success-anim">
        <ng-lottie class="d-flex-center" width="140px" height="140px" [options]="options"></ng-lottie>
        <img src="branding/theme/assets/static_assets/ic-check-round-on-lbg.svg" alt="">
      </div>
      @if (paymentDialog) {
        <div id="success-title">{{configService.localeKeys?.['account.your_account_is_ready.text']}}</div>
      }
      @if (coupon_valid == '' && !paymentDialog) {
        <div id="success-title">{{ configService.localeKeys?.['common_keys.brand_tagline.text'] }}</div>
      }
      @if (coupon_valid) {
        <div id="success-title">{{ configService.localeKeys?.['voucher.voucher_activated.text'] }}</div>
      }
      @if (accountCreate && coupon_valid == '') {
        <div id="account-msg">{{ configService.localeKeys?.['voucher.account_created.text'] }}</div>
      }
      @if (nextBillingDate) {
        <div class="subtitle-text" >{{nextBillingDate}}</div>
      }
      @if (subTitleText) {
        <div class="subtitle-msg" [ngClass]="{'dialog-bill':paymentDialog}">{{subTitleText}}</div>
      }
      <button (click)="mobileNavigate()" class="btn">
        <div class="d-flex align">
          <span>{{btnText}}</span>
          @if (!paymentDialog) {
            <img id="right-arrow" src="branding/theme/assets/static_assets/ic-left-arrow-on-lbg.svg">
          }
        </div>
      </button>
    </div>
  </div>

</div>